// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
// import Vue from "vue";
import '@/assets/styles/base.scss'
import '@/assets/styles/common.scss'
import '@/assets/iconfont/iconfont.css'
import App from "./App";
import router from "./router";  //页面文件,导致文件大的主要文件
import axios from "axios";   //大概50k
import ElementUI from "element-ui";
import VueResource from "vue-resource";  //文件导入,不压缩也只有12k
import "element-ui/lib/theme-chalk/index.css";
import iView from "iview";   //这是一个组件 ,如不需要则大可不必引用
import "iview/dist/styles/iview.css";
Vue.use(iView);
Vue.config.productionTip = false;
Vue.prototype.axios = axios;
Vue.use(ElementUI);
Vue.use(VueResource);
Vue.config.productionTip = false;
// axios.defaults.baseURL = "http://118.25.8.137:8080";
// axios.defaults.baseURL = "http://172.16.2.8:65523";
// axios.defaults.baseURL = "https://patsys.shlp.cn";
axios.defaults.baseURL = "";
// axios.defaults.baseURL = "http://192.168.31.226:8001";
// FastClick.attach(document.body);
// Vue.config.productionTip = false;
// axios
//   .get('./../static/serverconfig.json')
//   .then(result => {
//     sessionStorage.setItem('DeployLocation', result.data.DeployLocation)  //0 代表线上，1代表线下
//     console.log(sessionStorage.getItem("DeployLocation"))
//   })
//   .catch(error => {
//     console.log(error)
//   })


var timeout = 600
var newtime = 0

// 每隔一定时间发送心跳请求
setInterval(() => {
  newtime += 1
  if (newtime > timeout) {
    sessionStorage.clear();
    router.push('/login'); // 跳转到登录页面
    newtime = 0
  }
}, 1000);  // 5分钟

// 请求拦截器
axios.interceptors.request.use(
  (config) => {
    //表明当前有在操作
    newtime = 0;
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);



router.beforeEach((to, from, next) => {
  newtime = 0;
  if (to.meta.title) {
    document.title = to.meta.title;
  }
  if (to.path == "/login") {
    next();
  } else if (sessionStorage.getItem("staffNumber")) {
    next();
  } else {
    next("/login");
  }
});

new Vue({
  el: "#app",
  router,
  components: { App },
  template: "<App/>"
});




// WEBPACK FOOTER //
// ./src/main.js